import { EVENT_TYPES } from '../../constants';

export const toggleFilter = (types, visible) => ({
  payload: { types, visible },
  type: EVENT_TYPES.FILTERS_CHANGE,
});

export default toggleFilter;
